import { useState } from 'react';
import { LocationInventoryRecord, LocationRecordSection } from '../../../Api/Locations/locationsApi';
import { statusFormatter } from '../../../utils/helpers';
import { productLabel } from '../../../utils/productLabel';
import { RelatedRecordsCard } from '../../Compounds/RelatedRecordsTable/RelatedRecordsCard';
import { RelatedRecordsColumn } from '../../Compounds/RelatedRecordsTable/RelatedRecordsTable';
import { InventoryRecordDrawer } from '../../Compounds/InventoryRecordDrawer/InventoryRecordDrawer';
import { roleLabels } from './locationRoleLabels';

const NO_VALUE = '—';

const serviceLabel = (record: LocationInventoryRecord) =>
  record.productDisplay || (record.product ? productLabel(record.product) : '');

const statusLabel = (record: LocationInventoryRecord) => (record.status ? statusFormatter(record.status) : NO_VALUE);

const columns: RelatedRecordsColumn<LocationInventoryRecord>[] = [
  { header: 'Service', cellClass: 'break-words', text: serviceLabel },
  { header: 'Supplier', headerClass: 'w-28', cellClass: 'truncate', text: (record) => record.supplier?.name || '' },
  { header: 'Status', headerClass: 'w-28', text: statusLabel },
  { header: 'Role at this location', headerClass: 'w-32', text: (record) => roleLabels(record.location_roles) }
];

export interface LocationInventoryTableProps {
  inventory: LocationRecordSection<LocationInventoryRecord> | undefined;
  count: number | null | undefined;
}

export function LocationInventoryTable({ inventory, count }: LocationInventoryTableProps) {
  const [selectedAssetId, setSelectedAssetId] = useState<string | null>(null);

  return (
    <>
      <RelatedRecordsCard
        title="Inventory"
        count={count}
        section={inventory}
        emptyText="No inventory at this location."
        testId="location-inventory"
        recordKey={(record) => record.id}
        columns={columns}
        openTitle="Open Inventory"
        onOpen={(record) => setSelectedAssetId(record.id)}
      />
      {selectedAssetId && (
        <InventoryRecordDrawer
          assetId={selectedAssetId}
          onClose={() => setSelectedAssetId(null)}
          testIdPrefix="location-inventory"
        />
      )}
    </>
  );
}
